export class MagazineReuestDto{
	public isHome:boolean;
	public shouldLimited:boolean = true;
}